import { get } from '@api';

export const FETCH_JOURNAL_CONTENT_API_START = 'FETCH_JOURNAL_CONTENT_API_START';
export const FETCH_JOURNAL_CONTENT_API_SUCCESS = 'FETCH_JOURNAL_CONTENT_API_SUCCESS';
export const FETCH_JOURNAL_CONTENT_API_FAIL = 'FETCH_JOURNAL_CONTENT_API_FAIL';

const fetchJournalContentApiStart = (period) => ({
  type: FETCH_JOURNAL_CONTENT_API_START,
  payload: { period },
});

const fetchJournalContentApiSuccess = (payload) => ({
  type: FETCH_JOURNAL_CONTENT_API_SUCCESS,
  payload,
});

const fetchJournalContentApiFail = (error) => ({
  type: FETCH_JOURNAL_CONTENT_API_FAIL,
  payload: error,
});

/**
 * Загрузка статистики Content API за выбранный период.
 * Backend кэширует ответ в Redis на 60 секунд — повторный клик
 * по «Обновить» в пределах TTL вернёт тот же snapshot (см. fromCache).
 */
export const fetchJournalContentApi = ({ period }) => async (dispatch) => {
  dispatch(fetchJournalContentApiStart(period));
  try {
    const response = await get(`/journal/content-api-stats?period=${encodeURIComponent(period)}`);
    dispatch(fetchJournalContentApiSuccess({
      data: response.data,
      period,
    }));
  } catch (e) {
    console.error('fetchJournalContentApi error:', e);
    dispatch(fetchJournalContentApiFail(e));
  }
};
